module.exports = __webpack_public_path__ + "img/mtn.6501858d.png";